/**
 * Open Search Action
 * Triggered by: arc:action:searchOpen
 *
 * Adds or removes the 'search-visible' class on <body> when toggled on/off.
 * Usage: window.dispatchEvent(new CustomEvent('arc:action:searchOpen', { detail: { open: true } }))
 */

export const runSearchOpen = async (data = {}) => {
  try {
    const { open } = data;

    window.dispatchEvent(
      new CustomEvent('open-search', {
        detail: {}
      })
    );
    return {
      success: true,
      open
    };
  } catch (error) {
    console.error('runSearchOpen error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default runSearchOpen;
